<template>
  <section class="message__action">
    <div class="message__action--text">
      {{ content }}
    </div>
  </section>
</template>

<script>
export default {
  props: {
    content: { type: String, default: undefined }
  }
}
</script>

<style lang="scss">
@import '@/style/_non-rendering';
.message__action {
  padding: var(--gl-spacing-02);

  &--text {
    @extend %body-small;
    // --gl-color-shades-blue-40 with 0.2 opacity
    background: #d3e4ec;
    border-radius: var(--gl-border-radius-sm);
    color: var(--gl-color-shades-blue-40);
    display: table;
    margin: 0 auto;
    padding: var(--gl-spacing-01) var(--gl-spacing-04);
    text-align: center;

    & + & {
      margin-top: var(--gl-spacing-02);
    }
  }
}
</style>
